import { gql } from 'graphql-tag';

// Canonical fragments (build plan §3.3). Kept verbatim so the graphql repo's
// schema test validates exactly what the admin sends. Form fields are never
// a GraphQL type: they live inside `definition` (JSON), which Apollo stores
// opaquely, so reused field ids can't collide in the cache (plan §5.6).

export const FORM_CARD_FIELDS = gql`
  fragment FormCardFields on BuilderForm {
    id
    public_id
    name
    status
    archived_at
    revision
    account {
      id
      name
    }
    field_count
    submission_count
    note_count
    created_at
    updated_at
  }
`;

export const FORM_VERSION_FIELDS = gql`
  fragment FormVersionFields on FormVersion {
    id
    version_number
    definition
    field_count
    published_at
    created_at
    updated_at
  }
`;

export const FORM_DETAIL_FIELDS = gql`
  fragment FormDetailFields on BuilderForm {
    ...FormCardFields
    account {
      id
      name
      logo
    }
    kind
    slug
    w9_url
    description
    layout
    show_progress
    confirmation_email
    save_and_resume
    notify_on_submit
    notify_recipients {
      email
      name
      user_id
    }
    working_version {
      ...FormVersionFields
    }
    draft_version {
      id
    }
    published_version {
      id
      version_number
      published_at
    }
    assets {
      id
      purpose
      filename
      content_type
      size_bytes
      url
      created_at
    }
  }
  ${FORM_CARD_FIELDS}
  ${FORM_VERSION_FIELDS}
`;

export const FORM_SUBMISSION_ROW_FIELDS = gql`
  fragment FormSubmissionRowFields on FormSubmission {
    id
    reference
    form_id
    version_id
    source
    user_id
    submitter_name
    submitter_email
    answers
    submitted_at
    edited_at
    edited_by_name
    tax_year
    signed_ip
  }
`;

export const FORM_SUBMISSION_COLUMN_FIELDS = gql`
  fragment FormSubmissionColumnFields on FormSubmissionColumn {
    field_id
    label
    type
    position
    removed
  }
`;

// One queued export (the `exports` row behind Export submissions).
export const EXPORT_RUN_FIELDS = gql`
  fragment ExportRunFields on ExportRun {
    id
    report
    format
    status
    rows
    filename
    error
    created_at
    started_at
    finished_at
  }
`;
